export default __webpack_public_path__ + "images/e6407fdf0d260d07e20db3b264022db4-buildBuzz.webp";